import React from "react";
import useStores from "@hooks/useStores";
import LazyLoad from "@custom/LazyLoad";

const ContentAsset = ({ sys }) => {
	const { contentStore: store } = useStores();
	const asset = store.findAssetById(sys.id);

	return (
		<LazyLoad>
			<figure>
				<img
					src={asset.url}
					alt={asset.title}
					title={asset.description ? asset.description : asset.title}
					loading="lazy"
					decoding="async"
				/>
				<figcaption>{asset.title}</figcaption>
			</figure>
		</LazyLoad>
	);
};

export default ContentAsset;
